import React from "react";
import Axios from "axios";
import { createBrowserHistory } from "history";
import { useTranslation } from 'react-i18next';
import { makeStyles } from "@material-ui/core/styles";
import Header from "components/Header/Header.js";

import styles from "assets/jss/material-kit-react/views/landingPage.js";
import brandImage from "assets/img/iese-logo-navbar.png";
import ReactCountryFlag from "react-country-flag"
import { Button } from "@material-ui/core";
import SuccessInside from "views/SucessPage/SucessPageInside";
import config from "assets/config/config.json";
import { ClipLoader } from "react-spinners";


const useStyles = makeStyles(styles);

export default function SucessPage(props) {
    const { t } = useTranslation();
    var history = createBrowserHistory();
    const classes = useStyles();
    const { ...rest } = props;
    const [error, setError] = React.useState(null);
    const [isLoaded, setIsLoaded] = React.useState(false);
    const [items, setItems] = React.useState(null);

    React.useEffect(() => {
        Axios.get(config.checklogin)
            .then(
                (_result) => {
                    // Axios.get("/getuserdata")
                    Axios.get(config.getQuote)
                        .then(
                            (result) => {
                                if (result.data && !result.data.isExempt && result.data.isnotsubscribed) {
                                    history.replace('/personalinformation');
                                  } else {
                                    setItems(result.data);
                                    Axios.get("/getchecklastupdate")
                                    .then(
                                        (result) => {
                                            setIsLoaded(true);
                                        },
                                        (error) => {
                                            setIsLoaded(true);
                                            setError(error);
                                        })
                                  }
                            },
                            (error) => {
                                setIsLoaded(true);
                                setError(error);
                            })
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    setIsLoaded(false);
                    setError(error);
                }
            )
    }, []);
    if (error && error.response && error.response.status === 403) {
        history.replace('/auth');
        window.location.reload();
        console.log('SuccessPage: Error status 403');
    }
    else if (error && error.response && error.response.status === 400) {
        history.replace('/paymentmethod?errorid=400');
        window.location.reload();
        console.log('SuccessPage: Error status 400');
    }
    else if (error) {
        history.replace('/help');
        window.location.reload();
        console.log('SuccessPage: Generic error');
    }
    else if (!isLoaded) {
        console.log('SuccessPage: Not Loaded');
        return (
            <div>
          <Header key={1}
                color="transparent"
                brand={<img style={{ filter: "brightness(0) invert(1)" }}
                        src={brandImage}
                        className={classes.img}
                        alt="brand"
                    />}
                    fixed
                />
            <div
                style={{
                    position: 'absolute', left: '50%', top: '50%',
                    transform: 'translate(-50%, -50%)'
                }}
            >
                <ClipLoader

                    size={200}
                    color={"#504a4a"}
                />
            </div></div>);
    }
    else {
        return (
            <div>
                <Header key={2}
                    color="transparent"
                    brand={<img style={{ filter: "brightness(0) invert(1)" }}
                        src={brandImage}
                        className={classes.img}
                        alt="brand"
                    />}
                    fixed
                    userData={items}
                    {...rest}
                />
                <SuccessInside></SuccessInside>
            </div>
        );
    }
}